import React from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';

const DataTable = ({ columns, data, ...props }) => {
  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: true,
    enableSorting: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    muiTableBodyRowProps: { hover: false },
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        fontFamily: 'Nunito, sans-serif',
        fontSize: '11px',
        fontWeight: '700',
        color: '#4C444E',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        padding: '20px',
        backgroundColor: '#F3F4F5',
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontFamily: 'Nunito, sans-serif',
        padding: '16px 20px',
      },
    },
    ...props,
  });

  return <MaterialReactTable table={table} />;
};

export default DataTable;
